import React from "react";

const RelevésBancaires = () => {
  return (
    <div className="relevés-bancaires">
      <h2>Relevés bancaires</h2>
      <p>Liste et détail des relevés bancaires.</p>
    </div>
  );
};

export default RelevésBancaires;
